import FileDownload from 'js-file-download'
import json2csv from 'json2csv'
import { format } from 'date-fns'
const convertToCSV = json2csv.parse

const formatDate = date => {
  let dateArray = ''
  let month = ''
  let day = ''
  let year = ''

  if (date.length === 10) {
    dateArray = date.split('/')
    month = dateArray[0]
    day = dateArray[1]
    year = dateArray[2]
  } else {
    dateArray = date.split('-')
    month = dateArray[1]
    day = dateArray[2].substring(0, 2)
    year = dateArray[0]
  }
  switch (dateArray[1]) {
    case '02':
      month = 'Feb'
      break
    case '03':
      month = 'Mar'
      break
    case '04':
      month = 'Apr'
      break
    case '05':
      month = 'May'
      break
    case '06':
      month = 'Jun'
      break
    case '07':
      month = 'Jul'
      break
    case '08':
      month = 'Aug'
      break
    case '09':
      month = 'Sep'
      break
    case '10':
      month = 'Oct'
      break
    case '11':
      month = 'Nov'
      break
    case '12':
      month = 'Dec'
      break
    default:
      month = 'Jan'
  }
  return `${month} ${day}, ${year}`
}

const currentDate = () => {
  const dateArray = Date().split(' ')
  let month = ''
  const day = dateArray[2]
  const year = dateArray[3]
  switch (dateArray[1]) {
    case 'Feb':
      month = '02'
      break
    case 'Mar':
      month = '03'
      break
    case 'Apr':
      month = '04'
      break
    case 'May':
      month = '05'
      break
    case 'Jun':
      month = '06'
      break
    case 'Jul':
      month = '07'
      break
    case 'Aug':
      month = '08'
      break
    case 'Sep':
      month = '09'
      break
    case 'Oct':
      month = '10'
      break
    case 'Nov':
      month = '11'
      break
    case 'Dec':
      month = '12'
      break
    default:
      month = '01'
  }
  return `${year}-${month}-${day}`
}

const dateWithComma = date => {
  const newDate = date.split(' ')
  const month = newDate[0]
  const day = newDate[1]
  const year = newDate[2]
  return `${month} ${day}, ${year}`
}

export const DownloadPhase1 = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Request Type': obj.requestType,
      'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
      'Due Date': formatDate(obj.dueDate),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      'Amount Requested': obj.totalNetPrice,
      Department: obj.department.centerName,
      Status: obj.status
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}
export const DownloadPhase1AM = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Request Type': obj.requestType,
      'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
      'Expected Completion Date': obj.expectedCompletionDate
        ? dateWithComma(obj.expectedCompletionDate.substring(4, 15))
        : '',
      'Due Date': formatDate(obj.dueDate),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      'Amount Requested': obj.totalNetPrice,
      Department: obj.department.centerName,
      Status: obj.status
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadToApproved = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Request Type': obj.requestType,
      'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
      'Due Date': formatDate(obj.dueDate),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      'Amount Requested': obj.totalNetPrice.toFixed(2),
      Project: obj.project.projectName,
      Status: obj.status
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadApproved = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Request Type': obj.requestType,
      'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
      'Expected Completion Date': obj.expectedCompletionDate
        ? dateWithComma(obj.expectedCompletionDate.substring(4, 15))
        : '',
      'Due Date': formatDate(obj.dueDate),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      'Amount Requested': obj.totalNetPrice.toFixed(2),
      Project: obj.project.projectName,
      Status: obj.status
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadInProcess = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Request Type': obj.requestType,
      'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
      'Expected Completion Date': obj.expectedCompletionDate
        ? dateWithComma(obj.expectedCompletionDate.substring(4, 15))
        : '',
      'Due Date': formatDate(obj.dueDate),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      'Amount Requested': obj.totalNetPrice.toFixed(2),
      Department: obj.department.centerName,
      Requestor: `${obj.requestor.firstName} ${obj.requestor.lastName}`
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadPhase2 = arg => {
  const csvData = []
  let status = ''
  if (arg[1] === 'in process') {
    for (let obj of arg[0]) {
      csvData.push({
        'CRF#': obj.crfNo,
        'Request Type': obj.requestType,
        'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
        'Due Date': formatDate(obj.dueDate),
        'Project': obj.project.projectName,
        Vendor: obj.vendor.bpName,
        'Amount Requested': obj.totalNetPrice.toFixed(2),
        Department: obj.department.centerName
      })
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  if (arg[1] === 'check preparation') {
    for (let obj of arg[0]) {
      csvData.push({
        'CRF#': obj.crfNo,
        'Request Type': obj.requestType,
        'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
        'Due Date': formatDate(obj.dueDate),
        'Project': obj.project.projectName,
        Vendor: obj.vendor.bpName,
        'Check Amount': obj.totalNetPrice.toFixed(2),
        Department: obj.department.centerName
      })
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  if (arg[1] === 'check prepared') {
    for (let obj of arg[0]) {
      csvData.push({
        'CRF#': obj.crfNo,
        'Request Type': obj.requestType,
        'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
        'Expected Completion Date': dateWithComma(
          obj.expectedCompletionDate.substring(4, 15)
        ),
        'Due Date': formatDate(obj.dueDate),
        'Project': obj.project.projectName,
        Vendor: obj.vendor.bpName,
        'Check Amount': obj.totalNetPrice.toFixed(2)
      })
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  if (arg[1] === 'check available') {
    for (let obj of arg[0]) {
      csvData.push({
        'CRF#': obj.crfNo,
        'Request Type': obj.requestType,
        'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
        'Due Date': formatDate(obj.dueDate),
        'Project': obj.project.projectName,
        Vendor: obj.vendor.bpName,
        'Check Amount': obj.checkAmount.toFixed(2),
        'Check Date': obj.checkDate,
        'Check Number': obj.checkNo,
        'Check Available Date': formatDate(obj.checkAvailableDate),
        Department: obj.department.centerName
      })
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  if (arg[1] === 'released') {
    for (let obj of arg[0]) {
      csvData.push({
        'CRF#': obj.crfNo,
        'Request Type': obj.requestType,
        'Due Date': formatDate(obj.dueDate),
        'Project': obj.project.projectName,
        Vendor: obj.vendor.bpName,
        'Check Amount': obj.checkAmount.toFixed(2),
        'Check Available Date': formatDate(obj.checkAvailableDate),
        'Date Released': formatDate(obj.dateReleased),
        Department: obj.department.centerName
      })
      if (status === '' || status === obj.status) {
        status = obj.status
      } else {
        status = 'All_Request'
      }
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadCheckPreparation = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Request Type': obj.requestType,
      'Check Amount': obj.totalNetPrice,
      'APV#': obj.apvNo,
      'Posting Date': formatDate(obj.postingDate),
      'Due Date': formatDate(obj.dueDate),
      'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      Department: obj.department.centerName,
      Requestor: `${obj.requestor.firstName} ${obj.requestor.lastName}`
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadCheckPrepared = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Request Type': obj.requestType,
      'Check Amount': obj.checkAmount,
      'CV#': obj.cvNo,
      'Check Date': formatDate(obj.checkDate),
      'Due Date': formatDate(obj.dueDate),
      'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
      'Expected Completion Date': dateWithComma(
        obj.expectedCompletionDate.substring(4, 15)
      ),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      Department: obj.department.centerName,
      Requestor: `${obj.requestor.firstName} ${obj.requestor.lastName}`
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadCheckAvailable = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Request Type': obj.requestType,
      'Check Amount': obj.checkAmount,
      'Check Number': obj.checkNo,
      'Check Date': formatDate(obj.checkDate),
      'Date Created': dateWithComma(obj.creationDate.substring(4, 15)),
      'Due Date': formatDate(obj.dueDate),
      'Check Available Date': formatDate(obj.checkAvailableDate),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      Department: obj.department.centerName,
      Requestor: `${obj.requestor.firstName} ${obj.requestor.lastName}`
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

export const DownloadReleased = crfList => {
  const csvData = []
  let status = ''
  for (let obj of crfList) {
    csvData.push({
      'CRF#': obj.crfNo,
      'Due Date': formatDate(obj.dueDate),
      'Project': obj.project.projectName,
      Vendor: obj.vendor.bpName,
      'Check Amount': obj.checkAmount,
      'Check Available Date': formatDate(obj.checkAvailableDate),
      'Date Released': formatDate(obj.dateReleased),
      Department: obj.department.centerName,
      Requestor: `${obj.requestor.firstName} ${obj.requestor.lastName}`
    })
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }

  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}
